import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { ITeamPlayerDto } from '../../WorldDoomLeague';

interface TeamCurrentPlayersProps {
    currentPlayers: ITeamPlayerDto[];
}

const TeamCurrentPlayers = (props: TeamCurrentPlayersProps) => {
    return (
        <React.Fragment>
            <Card className='bg-danger mb-3'>
                <CardHeader>
                    Current Players
                </CardHeader>
                <CardBody>
                    {props.currentPlayers.map((s, idx) => (
                        <p className='text-center'><NavLink className='text-white' to={`/player/${s.playerId}`}>{s.playerName}</NavLink></p>
                    ))}
                </CardBody>
            </Card>
        </React.Fragment>
    );
};

export default TeamCurrentPlayers;